import { nanoid } from 'nanoid'

export function getDefaultItem() {
  return {
    id: 'new_' + nanoid(),
    title: '',
    description: '',
    kind: 'link',
    image: '',
    imageFile: '',
    emoji: '',
    textColor: '#FFFFFF',
    gradient: {
      from: 'transparent',
      to: '#323232'
    },
    link: '',
    page: '',
  }
}

export function useActiveItem(props) {
  function isActiveItem(item) {
    if (props.activeItem == null) return false
    return Object.is(props.activeItem, item)
  }

  return {
    isActiveItem
  }
}